// extracted by mini-css-extract-plugin
export default {"bellAnimation":"bellAnimation","bellRing":"bellRing","notificationCount":"notificationCount","notiCount-fig":"notiCount-fig"};